import React from 'react';
import { Provider } from "./components/ui/provider";
import { TooltipProvider } from "./components/tailwind/tooltip";
import { AppAlert } from "./components/shared/Alert";
import { Toaster } from "./components/ui/toaster";
import Routes from './routes/Routes';
import '@aws-amplify/ui-react/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import './App.css';
import withCustomAuthenticator from './withCustomAuthenticator';

function App() {
  return (
    <div className="app-container">
      <Provider>
        <TooltipProvider>
          <AppAlert />
          <Toaster />
          <Routes />
        </TooltipProvider>
      </Provider>
    </div>
  );
}

export default withCustomAuthenticator(App);